// Shared options and mapping for AI purpose modal and renderers

export const AIPURPOSE_OPTIONS = [
  {
    key: "Brand",
    title: "Brand",
    desc: "Posílit povědomí a vizuálně prezentovat značku.",
  },
  {
    key: "Akviziční",
    title: "Akviziční",
    desc: "Zaujmout a přilákat nové zákazníky.",
  },
  {
    key: "Konverzní",
    title: "Konverzní",
    desc: "Motivovat k akci: nákup, registrace či odeslání formuláře.",
  },
  {
    key: "Služba/nástroj",
    title: "Služba/nástroj",
    desc: "Prezentovat konkrétní službu nebo nástroj a vyzvat k vyzkoušení.",
  },
];

export const AI_TYPE_DESC_MAP = AIPURPOSE_OPTIONS.reduce((acc, cur) => {
  acc[cur.key] = cur.desc;
  return acc;
}, {});

// Normalize helper: lower-case and strip diacritics for resilient matching
const normalizeTypeKey = (s) =>
  String(s)
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const AI_TYPE_DESC_MAP_NORM = AIPURPOSE_OPTIONS.reduce((acc, cur) => {
  acc[normalizeTypeKey(cur.key)] = cur.desc;
  return acc;
}, {});

// Common aliases coming from server responses (normalized keys)
const AI_TYPE_ALIASES_NORM_TO_CANON = {
  [normalizeTypeKey("brandový")]: "Brand",
  [normalizeTypeKey("brandovy")]: "Brand",
  [normalizeTypeKey("brand")]: "Brand",
  [normalizeTypeKey("nástroj")]: "Služba/nástroj",
  [normalizeTypeKey("nastroj")]: "Služba/nástroj",
  [normalizeTypeKey("služba")]: "Služba/nástroj",
  [normalizeTypeKey("sluzba")]: "Služba/nástroj",
  [normalizeTypeKey("služba/nástroj")]: "Služba/nástroj",
  [normalizeTypeKey("sluzba/nastroj")]: "Služba/nástroj",
};

export const getAiTypeDescription = (type) => {
  if (type == null) return "";
  const raw = String(type).trim();
  // exact key first
  if (AI_TYPE_DESC_MAP[raw]) return AI_TYPE_DESC_MAP[raw];
  // normalized (case/diacritics-insensitive)
  const norm = normalizeTypeKey(raw);
  if (AI_TYPE_DESC_MAP_NORM[norm]) return AI_TYPE_DESC_MAP_NORM[norm];
  // alias fallback -> map to canonical key then resolve
  const canon = AI_TYPE_ALIASES_NORM_TO_CANON[norm];
  if (canon)
    return (
      AI_TYPE_DESC_MAP[canon] ||
      AI_TYPE_DESC_MAP_NORM[normalizeTypeKey(canon)] ||
      ""
    );
  return "";
};
